import {Button, Typography} from "antd";
import {formatDate} from "../utils/silverplus.utils.ts";
import {MESSAGES, SubscriptionState} from "../utils/silverplus.constants.ts";
import styled from "styled-components";

const { Text } = Typography;


export const SubscriptionEndInfo: React.FC<{
    subscriptionState: SubscriptionState;
    userPlanLabel?: string;
    onManageClick: () => void;
}> = ({ subscriptionState, userPlanLabel, onManageClick }) => {
    if (!subscriptionState.shouldShowInfo || !subscriptionState.endDate) {
        return null;
    }

    const formattedDate = formatDate(subscriptionState.endDate);
    const isCanceled = subscriptionState.type === 'showAsCanceled';

    const message = isCanceled
        ? `Ihr ${userPlanLabel} wurde gekündigt und endet am`
        : `Ihr ${userPlanLabel} hat eine Mindestlaufzeit bis zum`;

    const additionalInfo = isCanceled
        ? 'Sie haben weiterhin Zugang zu allen silver+ Features bis zu diesem Datum.'
        : 'Danach verlängert sich das Abonnement automatisch monatlich und kann jederzeit mit einmonatiger Kündigungsfrist gekündigt werden.';

    return (
        <SubscriptionInfo>
            <Text style={{ fontSize: '16px', color: '#666' }}>
                {message} <Text strong>{formattedDate}</Text>. {additionalInfo}
            </Text>
            {!isCanceled && (
                <Button
                    type="default"
                    size="middle"
                    style={{ marginLeft: 8 }}
                    onClick={onManageClick}
                >
                    {MESSAGES.buttons.manageSubscription}
                </Button>
            )}
        </SubscriptionInfo>
    );
};

const SubscriptionInfo = styled.div`
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 16px;
  margin: 20px 0;
  text-align: center;
`;

